import { Box, Typography } from "@mui/material";
import _ from "lodash";
import { ReactElement } from "react";

import PageContainer from "~frontend/components/PageContainer";
import { PageHeader } from "~frontend/components/PageHeader";
import { useBreadcrumbs } from "~frontend/providers/BreadcrumbsProvider";
import { useTenant } from "~frontend/providers/LoggedInUserProvider";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";
import { palette } from "~frontend/theme";

import SettingsForm from "./SettingsForm";

export function SubaccountSettings(): ReactElement {
  const tenant = useTenant()!;
  const { subaccountLink } = useSubaccount()!;
  useBreadcrumbs([
    {
      label: tenant.subaccountsEnabled ? "Subaccount Settings" : "Settings",
      path: subaccountLink("/settings"),
    },
  ]);

  return (
    <PageContainer maxWidth="lg">
      <PageHeader isSlim>Settings</PageHeader>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Configure your settings
        {tenant.subaccountsEnabled && " for this Subaccount"}.
      </Typography>

      <Box sx={{ backgroundColor: palette.white, p: 5 }}>
        <SettingsForm />
      </Box>
    </PageContainer>
  );
}
